/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_DeleteInputs */

const en_shared_delete = /** @type {(inputs: Shared_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

/** @type {(inputs: Shared_DeleteInputs) => LocalizedString} */
const de_shared_delete = en_shared_delete;

/** @type {(inputs: Shared_DeleteInputs) => LocalizedString} */
const es_shared_delete = en_shared_delete;

/** @type {(inputs: Shared_DeleteInputs) => LocalizedString} */
const fr_shared_delete = en_shared_delete;

/** @type {(inputs: Shared_DeleteInputs) => LocalizedString} */
const it_shared_delete = en_shared_delete;

/** @type {(inputs: Shared_DeleteInputs) => LocalizedString} */
const pt_br2_shared_delete = en_shared_delete;

/** @type {(inputs: Shared_DeleteInputs) => LocalizedString} */
const pl_shared_delete = en_shared_delete;

/** @type {(inputs: Shared_DeleteInputs) => LocalizedString} */
const hu_shared_delete = en_shared_delete;

/** @type {(inputs: Shared_DeleteInputs) => LocalizedString} */
const ro_shared_delete = en_shared_delete;

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Shared_DeleteInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_delete = /** @type {((inputs?: Shared_DeleteInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_DeleteInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_delete(inputs)
	if (locale === "de") return de_shared_delete(inputs)
	if (locale === "es") return es_shared_delete(inputs)
	if (locale === "fr") return fr_shared_delete(inputs)
	if (locale === "it") return it_shared_delete(inputs)
	if (locale === "pt-BR") return pt_br2_shared_delete(inputs)
	if (locale === "pl") return pl_shared_delete(inputs)
	if (locale === "hu") return hu_shared_delete(inputs)
	return ro_shared_delete(inputs)
});
export { shared_delete as "shared.delete" }